import i18n from 'i18next';

export const columns = [
  {
    id: 'vehicle',
    numeric: false,
    disablePadding: true,
    label: i18n.t('camera.vehicle'),
    needSorting: true,
  },
  {
    id: 'count',
    numeric: false,
    disablePadding: false,
    label: i18n.t('cameraEvents.totalcounts'),
    needSorting: true,
  },
];

export const sortColumnMapping = {
  vehicle: 'vehicleName',
  count: 'eventCount',
};

export const basicRequest = {
  displayStart: 1,
  displayLength: 10,
};
